(function ($) {

'use strict';

	/**
	 * Initialize the sliders
	 */
	$.fn.sliderInit = function () {
		/**
		 * Sort slides by src attribute of img tags
		 * @param {type} a
		 * @param {type} b
		 * @returns int if name of the src attribute is lesser (-1), equal (0) or greater (1)
		 */
		function sortSlides(a, b) {
			var title1 = $(a).find('img').attr('src');
			var title2 = $(b).find('img').attr('src');

			return ((title1 < title2) ? -1 : ((title1 > title2) ? 1 : 0));
		}

		/**
		 * reload all sliders
		 * @returns {undefined}
		 */
		function reloadActiveSliders(force) {
			clearTimeout(resizeTimoutID);
			resizeTimoutID = setTimeout(function () {

				if (force || windowWidth !== $(window).width()) {
					$(window).off('resize.activeslider');
					$(document).off('reloadsliders:force');
					for (var i = 0; i < $activeSliders.length; i++) {
						$activeSliders[i].destroySlider();
					}

					$activeSliders = [];
					createSliders();
				}
			}, 50);
		}

		/**
		 * Creates alle sliders
		 * @returns {undefined}
		 */
		function createSliders() {
			windowWidth = $(window).width();

			//remove resize handler
			$(window).off('resize.activeslider');
			$(document).off('reloadsliders:force');

			// load default sliders. Sliders with the 'nodefault' class will not be included.
			$('.custpart-slider, .product-preview-slider, .article-preview-slider, .area-preview-slider').not('.nodefault').each(function () {
				var $slider = $(this);
				var $singleSlide = $slider.find('.slide');
				var slideWidth = $singleSlide.width(); //150;
				var slideMargin = 10; //($slider.hasClass('area-preview-slider') ? 10 : 5);
				var slidesPerPage = ($slider.hasClass('article-preview-slider') ? 1
						: Math.max(1, Math.min(4,parseInt($slider.parent().width() / (slideWidth + slideMargin)))));
				var slideCount = $singleSlide.length;
				var slidePause = $.numParamFromAttr($slider, 'data-slider-pause', ($slider.hasClass('product-preview-slider') ? 10000 : 6000));
				var usePager = (slideCount > slidesPerPage &&
						$.numParamFromAttr($slider, 'data-slider-pager',
								($slider.hasClass('article-preview-slider') || $slider.hasClass('custpart-slider')),
								true));
				var useControls = (slideCount > slidesPerPage &&
						$.numParamFromAttr($slider, 'data-slider-ctrls',
								($slider.hasClass('product-preview-slider') || $slider.hasClass('article-preview-slider') || $slider.hasClass('area-preview-slider')),
								true));
				var autoRun = (slideCount > slidesPerPage &&
						$.numParamFromAttr($slider, 'data-slider-auto',
								$.morejs_options.slidersGlobal.sliderAutoRun,
								true));
				var sliderSpeed = (slideCount > slidesPerPage &&
						$.numParamFromAttr($slider, 'data-slider-speed', sliderDefaultSpeed));
				var useTouch = ($slider.find('a').length > 0) ? false : true; // touch controls interfere with links/click handlers


				$activeSliders.push($slider.bxSlider({
					slideWidth: slideWidth,
					minSlides: 1,
					maxSlides: slidesPerPage,
					moveSlides: slidesPerPage,
					slideMargin: slideMargin,
					auto: autoRun,
					stopAutoOnClick: $.morejs_options.slidersGlobal.stopAutoOnClick,
					autoHover: true,
//						touchEnabled: false,
					speed: sliderSpeed,
					pause: slidePause,
					//						autoControls: (slideCount > slidesPerPage && $(this).hasClass('product-preview-slider')),
					//						autoControlsCombine: true,
					pager: usePager,
					controls: useControls,
					touchEnabled: useTouch,
					onSlideBefore: function () {
						$(this).closest('.bx-wrapper').find('.bx-controls').addClass('hidden');
					},
					onSlideAfter: function () {
						$(this).closest('.bx-wrapper').find('.bx-controls').removeClass('hidden');
					},
				}));
			});

			// load video gallery
			$('.video-slider').each(function() {
				var $slider = $(this);
				var slideWidth = 150;
				var slideMargin = 10;
				var slidesPerPage = Math.max(1, parseInt($('.video-slider').parent().width() / (slideWidth + slideMargin)));
				var slideCount = $slider.find('.slide').length;
				var autoRun = (slideCount > slidesPerPage &&
						$.numParamFromAttr($slider, 'data-slider-auto',
								$.morejs_options.slidersGlobal.sliderAutoRun,
								true));
				var sliderSpeed = (slideCount > slidesPerPage &&
						$.numParamFromAttr($slider, 'data-slider-speed', sliderDefaultSpeed));

				$activeSliders.push($slider.bxSlider({
					slideWidth: slideWidth,
					slideMargin: slideMargin,
					maxSlides: slidesPerPage,
					adaptiveHeight: false,
					touchEnabled: false,
					autoHover: true,
					auto: autoRun,
					stopAutoOnClick: $.morejs_options.slidersGlobal.stopAutoOnClick,
					speed: sliderSpeed,
					onSliderLoad: function () {
						$(this).find('.slide').show();
						// find the 1st slide by sortorder of the img name
						var $firstSlide = null;
						var elems = $('.video-slider .slide.bx-clone').toArray();

						if (elems.length > 0) {
							elems.sort(sortSlides);

							var elemHeight = 0;

							for (var i = 0; i < elems.length && i < slidesPerPage; i++) {
								if (i === 0) {
									$firstSlide = $(elems[i]);
								}
								elemHeight = Math.max(elemHeight, $(elems[i]).height());
							}

							$('.video-slider-container .bx-viewport').css('height', elemHeight);

							if ($firstSlide.length > 0) {
								var $selectedSlide = $('.video-slider .slide img[src="' + $firstSlide.find('img').attr('src') + '"]');
								if ($selectedSlide.length > 0) {
									$selectedSlide.parents('.video-slider .slide').loadVideo(false);
								}
							}
						}
						// hide page controls if only 1 page exists
						if (slideCount <= slidesPerPage) {
							$slider.parents('.bx-wrapper').find('.bx-pager-item').hide();
						}
						// slide click handler
						$('.video-slider-container .slide').on('click', function (e) {
							$(this).loadVideo(true, {
								videoID: $(this).attr('data-idx')
							});
							return false;
						});
						// handle video play event to set the class active
						$('.video-slider-container video').on('play', function () {
							$(this).parents('.video-slider-container').find('img[src="' + $(this).attr('poster') + '"]').parents('.imglink').addClass('active');
							;
						});
					},
					onSlideBefore: function () {
						$(this).closest('.bx-wrapper').find('.bx-controls').addClass('hidden');
					},
					onSlideAfter: function () {
						$(this).closest('.bx-wrapper').find('.bx-controls').removeClass('hidden');
					},
				}));
			});


			// load image gallery
			$('.image-slider').each(function () {
				var $slider = $(this);
				var slideWidth = 290;
				var slideMargin = 10;
				var slidesPerPage = Math.max(1, parseInt($(this).parent().width() / (slideWidth + slideMargin)));
				var slideCount = $slider.find('.slide').length;
				var slidePause = $.numParamFromAttr($slider.closest('.image-slider-container'), 'data-slider-pause', 6000);
				var autoRun = (slideCount > slidesPerPage && slidePause > 0 &&
						$.numParamFromAttr($slider, 'data-slider-auto',
								$.morejs_options.slidersGlobal.sliderAutoRun,
								true));

				$activeSliders.push($slider.bxSlider({
					slideWidth: slideWidth,
					slideMargin: slideMargin,
					maxSlides: slidesPerPage,
					adaptiveHeight: false,
					touchEnabled: false,
					autoHover: true,
					auto: autoRun,
					stopAutoOnClick: $.morejs_options.slidersGlobal.stopAutoOnClick,
					speed: 1500,
					pause: slidePause,
					onSliderLoad: function () {
						var $slides = $(this).find('.slide');
						$slides.show();

						// find the 1st slide by sortorder of the img name
						var $firstSlide = null;
						var elems = $(this).find('.slide.bx-clone').toArray();

						if (elems.length > 0) {
							if ($(this).hasClass('nosort') === false) {
								elems.sort(sortSlides);
							}

							$firstSlide = $(this).find('.slide').not('.bx-clone').first();

							if ($firstSlide.length > 0) {
								var $selectedSlide = $(this).find('.slide img[src="' + $firstSlide.find('img').attr('src') + '"]');
								if ($selectedSlide.length > 0) {
									$selectedSlide.closest('.slide').loadImage();
								}
							}
						}

						// slide click handler

						// hide page controls if only 1 page exists
						if (slideCount <= slidesPerPage) {
							$slider.closest('.bx-wrapper').find('.bx-pager-item').hide();
						}

						$(this).find('.slide').on('click', function (e) {
							$(this).loadImage();

							return false;
						});

						$('.active-image-container img').css('cursor', 'pointer');
					},
					onSlideBefore: function () {
						$(this).closest('.bx-wrapper').find('.bx-controls').addClass('hidden');
					},
					onSlideAfter: function () {
						$(this).closest('.bx-wrapper').find('.bx-controls').removeClass('hidden');
					},

				}));
			});

			// load image-only gallery
			$('.imageonly-slider').each(function () {
				var $slider = $(this);
				var slideWidth = 0;
				var slideMargin = 10;
				var slidesPerPage = 1;

				$activeSliders.push($slider.bxSlider({
					slideWidth: slideWidth,
					slideMargin: slideMargin,
					maxSlides: slidesPerPage,
					auto: false,
					adaptiveHeight: true,
					pagerType: 'short',
					onSliderLoad: function () {

						$(this).find('.slide').show();
						// find the 1st slide by sortorder of the img name
						var $firstSlide = null;
						var elems = $(this).find('.slide.bx-clone').toArray();

						if (elems.length > 0) {
							if ($(this).hasClass('nosort') === false) {
								elems.sort(sortSlides);
							}
						}

						var $bxWrapper = $slider.parents('.bx-wrapper');
						$bxWrapper.addClass('bottomcontrols');

						// add first and last slide links
						var $bxControlContainer = $bxWrapper.find('.bx-controls-direction').first();
						if ($bxControlContainer.length > 0)
						{
							// first slide link
							var $btn = $('<a class="bx-first" href="javascript:;">Erste Seite</a>');
							$btn.on('click', function () {
								$slider.goToSlide(0);
							});
							$bxControlContainer.first().prepend($btn);
							// last slide link
							var $btn = $('<a class="bx-last" href="javascript:;">Letzte Seite</a>');
							$btn.on('click', function () {
								$slider.goToSlide($slider.getSlideCount() - 1);
							});
							$bxControlContainer.first().append($btn);
						}

						$(this).closest('.bx-wrapper').find('.bx-controls').addClass('extracontrols');

					},
					onSlideBefore: function () {
						$(this).closest('.bx-wrapper').find('.bx-controls').addClass('hidden');
					},
					onSlideAfter: function () {
						$(this).closest('.bx-wrapper').find('.bx-controls').removeClass('hidden');
					},
				}));
			});

			// load image gallery
			$('.product-slider').each(function () {
				var $slider = $(this);
				var slideWidth = 100;
				var slideMargin = 10;
				var slidesPerPage = Math.max(1, parseInt($slider.parent().width() / (slideWidth + slideMargin)));
				var slideCount = $slider.find('.slide').length;
				var autoRun = (slideCount > slidesPerPage &&
						$.numParamFromAttr($slider, 'data-slider-auto',
								$.morejs_options.slidersGlobal.sliderAutoRun,
								true));

				$activeSliders.push($slider.bxSlider({
					slideWidth: slideWidth,
					slideMargin: slideMargin,
					maxSlides: slidesPerPage,
					auto: autoRun,
					stopAutoOnClick: $.morejs_options.slidersGlobal.stopAutoOnClick,
					autoHover: true,
					adaptiveHeight: false,
					touchEnabled: false,
					speed: 1000,
					onSliderLoad: function () {
						var loadImageOptions = {
							containerSelector: '.product-slider-container',
							imgLinkSelector: '.product-slider .imglink',
							imageSelector: '.active-product-container img'
						};

						$(this).find('.slide').show();
						// find the 1st slide by sortorder of the img name
						var $firstSlide = null;
						var elems = $(this).find('.slide.bx-clone').toArray();

						if (elems.length > 0) {
							if ($(this).hasClass('nosort') === false) {
								elems.sort(sortSlides);
							}

							$firstSlide = $(this).find('.slide').not('.bx-clone').first();
							if ($firstSlide.length > 0) {
								$firstSlide.loadImage(loadImageOptions);
							}
						}
						// slide click handler

						// hide page controls if only 1 page exists
						if (slideCount <= slidesPerPage) {
							$slider.parents('.bx-wrapper').find('.bx-pager-item').hide();
						}

						$(this).find('.slide').on('click', function (e) {
							$(this).loadImage(loadImageOptions);

							return false;
						});

					},
					onSlideBefore: function () {
						$(this).closest('.bx-wrapper').find('.bx-controls').addClass('hidden');
					},
					onSlideAfter: function () {
						$(this).closest('.bx-wrapper').find('.bx-controls').removeClass('hidden');
					},
				}));

				if ($('.product-slider .slide').not('.bx-clone').length <= 1) {
					$('.product-slider-container .bx-wrapper').css('display', 'none');
				}
			});

			// initialize sliders from custom.js
			if (typeof $.morejs_options.customSlidersInit === 'function') {
				$.morejs_options.customSlidersInit($activeSliders);
			}

			if ($activeSliders.length > 0) {
				// lightbox handler for active img
				var $lightboxElems = $('.active-image-container, .active-product-container');
				if ($lightboxElems.length > 0) {
					$.loadLightboxJs(function () {

						function showLightbox() {
							var $activeImgContainer = $(this);
							$activeImgContainer.off('click', showLightbox);

							var $img = $(this).find('img');
							// clone image and lightbox the clone
							var lb = $('<div style="max-width: 100% max-height: 90vh" />');
							var clone = $('<img/>');
							clone.one('load', function () {
								if (this.width <= $activeImgContainer.width() + 50 &&
										this.height <= $activeImgContainer.height() + 50) {
									clone.width(this.width * 1.3);
									clone.height(this.height * 1.3);
								} else {
									clone.width(this.width);
									clone.height(this.height);
								}

								clone.css({
									height: 'auto',
									'max-width': '100%',
									'max-height': '85vh',
									'z-index': 9999,
									width: 'auto'
								});
								lb.lightbox_me_start(clone, {
									onClose: function () {
										$activeImgContainer.off('click').on('click', showLightbox);
									}
								});
							}).attr('src', $img.attr('src'));
						}

						$lightboxElems.off('click').on('click', showLightbox);

					});
				}

				//				// remove cloned elements from tabindex for accassibility reasons
				$('.slide.bx-clone a').attr('tabindex', '-1');
				var $slides = $('.slide:not(.bx-clone)');
				$slides.attr('aria-hidden', 'false');
				$slides.find('a').attr('aria-hidden', 'false');
				$('.bx-controls a').attr('aria-hidden', 'true');

				var prevText = $.i81n.text('SLIDER_PREV');
				var nextText = $.i81n.text('SLIDER_NEXT');
				$('.bx-controls a.bx-prev').attr('alt', prevText).attr('title', prevText).text(prevText);
				$('.bx-controls a.bx-next').attr('alt', nextText).attr('title', nextText).text(nextText);

				$activeSliders.forEach(function (e, i) {
					e.onSlideNext = function ($slideElement, oldIndex, newIndex) {
						console.log('onSlideNext');
						e.stopAuto();
						setTimeout(function () {
							e.startAuto();
							console.log('startAuto');
						}, 3000);
					};
				});


				$(window).on('resize.activeslider', function() {
					reloadActiveSliders();
				});
				$(window).on('resize.activesliderForce', function() {
					reloadActiveSliders(true);
				});
			}
		}
		
		/////////////////////
		// main code
		if ($(this).length < 1) {
			return 0;
		}

		var sliderDefaultSpeed = 1500;
		var windowWidth = 0;
		var resizeTimoutID = 0;
		var $activeSliders = [];

		var $sliders = $('.custpart-slider, .video-slider, .image-slider, .imageonly-slider, .product-slider, .product-preview-slider, .article-preview-slider, .area-preview-slider, .refartslider');

		// load bx-slider CSS if required
		if ($sliders.length > 0 || typeof $.morejs_options.customSlidersInit === 'function') {

			// load the bxslider and trigger to initialize the sliders via resize event
			$.loadBxSliderJs(function () {
				// 1st slider init
				$(window).on('resize.activeslider', function() {
					reloadActiveSliders();
				});
				$(document).on('reloadsliders:force', function() {
					reloadActiveSliders(true);
				});

				$(document).trigger('reloadsliders:force');

			});

		}	// if sliders used
	}; // $.fn.sliderInit

}(jQuery));